import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash"
import {Empty, Modal, notification} from "antd";
import
{
	Button,
	Loading,
	Icon
} from "~/components";
import ActionBar from "~/layout/ActionBar";
import
{
	handleRequest,
	apiError,
} from "~/utils";
import
{
	useCan
} from "~/hooks";
import
{
	attributeApi
} from "~/api";
import {
	AttributeSearchBar,
	AttributeTable,
	AttributeFormAddEdit,
} from "../components";
import {
	attributeActions,
	attributeErrorSelector,
	attributeFilterSelector,
	attributeItemsSelector,
	attributeLoadingSelector,
	attributePaginationSelector
} from "../../../reduxs/Attribute/attributeSlice";


function Attribute()
{
	const can = {
	    add : useCan('attribute_add'),
	    edit : useCan('attribute_edit'),
	    delete : useCan('attribute_delete')
	}

	const dispatch  = useDispatch();

	const items     = useSelector(attributeItemsSelector);

	const loading   = useSelector(attributeLoadingSelector);

	const error     = useSelector(attributeErrorSelector);

	const pagination = useSelector(attributePaginationSelector);

	const filter    = useSelector(attributeFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const eventHandlers =
	{
		openModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: true }));
		}, []),

		closeModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: false }));
		}, []),

		load: useCallback(() =>
		{
			dispatch(attributeActions.fetchData(filter));
		}, [dispatch, filter]),

		paginationChange: (page) =>
		{
			dispatch(attributeActions.setFilter({...filter, page }));
		},

		search: (newFilter) =>
		{
			dispatch(attributeActions.setFilterWithDebounce(newFilter));
		},

		filterChange: (key, value) =>
		{
			const newFilter = {
				...filter,
				[key]: value,
				page: 1
			};
			dispatch(attributeActions.setFilter(newFilter));
		},

		add: async (data) =>
		{
			let [error, response] = await handleRequest(attributeApi.add(data));

			let message = apiError(`Thêm thuộc tính thất bại`, error, response);

			if(!message)
			{
				notification.success({message: 'Thành công', description: `Thêm thuộc tính thành công`});

				dispatch(attributeActions.add(response.data));

				eventHandlers.closeModal('addEdit')
			}
		},

		edit: async (item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin thuộc tính để cập nhật'});
				return;
			}

			setItemEdit(item);

			let [error, response] = await handleRequest(attributeApi.get(item.id));

			if(!apiError(`Lấy thông tin thuộc tính thất bại`, error, response))
			{
				setItemEdit(response.data);
				eventHandlers.openModal('addEdit');
			}
		},

		update: async (data, item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin thuộc tính để cập nhật'});
				return;
			}

			data.id = item.id;

			let [error, response] = await handleRequest(attributeApi.update(data));

			if(!apiError(`Cập nhật thông tin thuộc tính thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `Cập nhật thông tin thuộc tính thành công`});

				dispatch(attributeActions.update({
					...item,
					...response.data
				}));

				eventHandlers.closeModal('addEdit')
			}
		},

		deleteConfirm: (item) =>
		{
			setItemEdit(item);
			eventHandlers.openModal('delete');
		},

		//Delete
		delete: async () =>
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin thuộc tính để xóa'});
				return;
			}

			let [error, response] = await handleRequest(attributeApi.delete(itemEdit.id));

			if(!apiError(`xóa thuộc tính thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `xóa thuộc tính thành công`});

				dispatch(attributeActions.delete(itemEdit.id));

				eventHandlers.closeModal('delete')
			}
		}
	}

	//Load data
	useEffect(() =>
	{
		let isMounted = true;
		if (isMounted) eventHandlers.load();
		return () => { isMounted = false };
	}, [filter]);

	return (
		<>
			<ActionBar title={'Thuộc tính sản phẩm'}>
				{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); eventHandlers.openModal('addEdit')}}>Thêm mới</Button>}
				<Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content p-2">
					{loading && <Loading/>}
					{<AttributeSearchBar filter={filter} onSearchChange={eventHandlers.search} onChange={eventHandlers.filterChange} can={can} />}
					{_.isEmpty(items) && <Empty />}
					{!_.isEmpty(items) && <AttributeTable
							items={items}
							pagination={pagination}
							onPaginationChange={eventHandlers.paginationChange}
							onEdit={eventHandlers.edit}
							onDelete={eventHandlers.deleteConfirm}
							can={can}
					/>}
				</div>
				{
					(can.add || can.edit) && <Modal
						title="Thuộc tính sản phẩm"
						centered
						width={1000}
						open={openModal.addEdit}
						onCancel={() => {eventHandlers.closeModal('addEdit')}}
						footer={null}
					>
						<AttributeFormAddEdit item={itemEdit}
											 onAdd={eventHandlers.add}
											 onUpdate={eventHandlers.update}
						/>
					</Modal>
				}
				{
					(can.delete && itemEdit?.id) && <Modal
						title="Xóa thuộc tính"
						open={openModal.delete}
						onOk={eventHandlers.delete}
						okType={'danger'}
						onCancel={() => {eventHandlers.closeModal('delete')}}
					>
						<p>Bạn muốn xóa thuộc tính <b>{itemEdit?.name}</b>?</p>
					</Modal>
				}
			</div>
		</>
	)
}

export default Attribute;
